/**
 * Service for persisting dev/test itinerary reviews via the backend API.
 */

import axios, { type AxiosInstance } from "axios";
import { CreateItineraryReviewDto } from "../types/dtos/api/itinerary-review/create-itinerary-review.dto";
import { ItineraryReviewResponseDto } from "../types/dtos/api/itinerary-review/itinerary-review-response.dto";
import { registerFlowCorrelationInterceptors } from "./http/correlationItineraryAxios";

const axiosInstance: AxiosInstance = axios.create();
registerFlowCorrelationInterceptors( axiosInstance );

class ItineraryReviewServiceClass {

    private readonly apiUrl = "/api/itinerary-review";

    /**
     * Persists a reviewer score and optional comment for an itinerary snapshot.
     *
     * @param payload - Review data from the modal form.
     * @returns Persisted review metadata from the backend.
     */
    async createReview( payload: CreateItineraryReviewDto ): Promise<ItineraryReviewResponseDto> {
        const response = await axiosInstance.post<ItineraryReviewResponseDto>( this.apiUrl, payload );

        return response.data;
    }

}

export const itineraryReviewService = new ItineraryReviewServiceClass();
